import { useCallback } from "react";
import { withContractPricing } from "../../utils/helper";

const useCliLineManagement = (cli, setCli, contractLength) => {
  const handleChangeLegacyValue = useCallback(
    (e, mainIndex) => {
      const tariff = withContractPricing(e, contractLength);
      let tempArray = JSON.parse(JSON.stringify(cli));
      let updatedObj = tempArray[mainIndex].lineValues.map((val) => {
        return {
          ...val,
          legacy: tariff,
        };
      });
      tempArray[mainIndex].lineValues = updatedObj;
      setCli(tempArray);
    },
    [cli, setCli, contractLength]
  );

  const handleChangeLegacyService = useCallback(
    (e, mainIndex, index, key) => {
      const tariff = withContractPricing(e, contractLength);
      let tempArray = JSON.parse(JSON.stringify(cli));

      let updated = tempArray[mainIndex].lineValues.map((val) => {
        return {
          ...val,
          [key]: tariff,
        };
      });

      tempArray[mainIndex].lineValues = updated;
      setCli(tempArray);
    },
    [cli, setCli, contractLength]
  );

  const handleChangeNgnValue = useCallback(
    (e, mainIndex, index, key) => {
      const tariff = withContractPricing(e, contractLength);
      let tempArray = JSON.parse(JSON.stringify(cli));
      tempArray[mainIndex].lineValues[index][key] = tariff;
      setCli(tempArray);
    },
    [cli, setCli, contractLength]
  );

  const handleChangeNgnService = useCallback(
    (e, mainIndex, index, key) => {
      const tariff = withContractPricing(e, contractLength);
      let tempArray = JSON.parse(JSON.stringify(cli));
      tempArray[mainIndex].lineValues[index][key] = tariff;
      setCli(tempArray);
    },
    [cli, setCli, contractLength]
  );

  return {
    handleChangeLegacyValue,
    handleChangeLegacyService,
    handleChangeNgnValue,
    handleChangeNgnService,
  };
};

export default useCliLineManagement;
